export interface FAQItem {
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    question: '美女网站最适合使用什么色系？',
    answer: '根据品牌定位不同，推荐以下三大主流色系：柔和暖调（玫瑰金、奶油色、珊瑚粉）适合高端护肤和轻奢品牌；清新粉彩（薄荷绿、婴儿蓝、淡丁香）适合年轻时尚和生活方式品牌；大地暖色（燕麦色、陶土色、巧克力棕）适合天然有机和母婴品牌。关键是根据目标用户画像选择最能引发情感共鸣的色调。',
  },
  {
    question: '如何为女性品牌选择合适的配色比例？',
    answer: '推荐采用6:3:1黄金比例法则：主色占60%（页面背景和大型区块），辅助色占30%（次要区块、卡片背景），强调色占10%（按钮、重要标签、CTA区域）。这个比例能确保页面视觉层次清晰，同时保持品牌调性统一。对于奢侈品牌，可适当增加中性色比例至7:2:1。',
  },
  {
    question: '粉色系在女性网站设计中会显得过于甜腻吗？',
    answer: '关键在于粉色的饱和度和使用比例。低饱和度的灰调粉（如干枯玫瑰色、豆沙粉）不仅不会甜腻，反而能传递高级感。同时控制粉色使用面积不超过40%，搭配大量中性色和留白，能有效避免"甜腻"印象。建议在粉色中加入10-15%的灰调来增加成熟感。',
  },
  {
    question: '女性网站需要适配深色模式吗？',
    answer: '强烈建议适配。数据显示超过60%的年轻女性用户习惯使用深色模式浏览。在深色模式下，需要将品牌色进行"提亮处理"——提升明度15-20%以维持对比度。同时，柔和色调在深色背景上需要适度提升饱和度，避免颜色被深色背景"吞没"。',
  },
  {
    question: '如何确保柔和的配色不影响网站可读性？',
    answer: '使用WCAG对比度检查工具验证所有文字与背景的组合。对于女性网站常用的柔和配色，建议：正文与背景对比度不低于4.5:1（AA级）；增大正文字号至16px以上；避免将浅色文字放在柔和彩色背景上；为重要操作按钮使用对比度更高的强调色。这样既保持优雅调性，又确保良好的可读性。',
  },
  {
    question: '色彩趋势变化太快，如何设计一个不过时的配色方案？',
    answer: '以中性色为基础构建色彩体系。米色、奶油色、暖灰色等中性色具有极强的时间抗性，不会因为潮流变化而过时。将品牌专属色控制在20%以内，便于未来微调。建议每年对品牌色进行5-10%的微调（如稍降饱和度、微调色相），而非彻底的改头换面。',
  },
  {
    question: '不同文化背景的女性用户对色彩的偏好有何差异？',
    answer: '日韩用户偏好低饱和、高透明感的配色；欧美用户接受度更广，从极简中性到大胆撞色都有市场；东南亚用户偏爱温暖明亮的色调；中东用户对金色和宝石色调有特殊偏好。面向多文化市场时，建议采用中性色为主、文化适配色为辅的模块化色彩策略。',
  },
];